import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const B2ETP = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<div>
			<Navbar />
			<div
				style={{
					backgroundImage:
						"url('https://aryaaviation.com/assets/images/travel-website-development.jpg')",
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					B2E Travel Portal
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					B2E Travel Portal
				</h6>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					B2E Booking System
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/b2e-travel-portal.jpg' />
						</Grid>
						<Grid item xs={8}>
							<p>
								B2E Travel Portal is the Travel Portal which helps Corporate
								Travelers to have Real Time Flight, Hotel and Other Travel
								Bookings. This Travel Portal facilitates to book for the
								Corporate or for Personal Trips. B2E Travel Portal is the Travel
								Portal which helps Corporate Travelers to have Real Time Flight,
								Hotel and Other Travel Bookings. This Travel Portal facilitates
								to book for the Corporate or for Personal Trips.
							</p>
							<br />
							<p>
								Our B2E Travel portal offers a flexible online booking to serve
								their business requirements Hassle-Free. B2E Travel Portal have
								all the services like Flight Booking, Hotel Booking, Bus Booking
								and Car Booking.
							</p>
							<p>
								Arya Aviation provides the best B2E Travel Portal as our team is
								having the 11+ years great experience in the Travel Technology.
								In B2E Travel Portal you can create the Corporate or Enterprise
								login IDs so that they can book the Flight, Hotel, Bus or Car
								through their dashboards. Corporates can also send the
								cancellation request of Flight, Hotel, Bus or Car from their
								dashboards as well. Corporate agents can also check previous
								bookings details, set reminder before travel date, share details
								to passenger etc. Corporate Agents do Flight Booking, Hotel
								Booking, Car Booking and Bus Booking with the help of Agency
								Wallet System so they can avoid additional payment gateway
								transaction charges. Corporate Agent can check the Transaction
								Log, Credit Log, total due balance, transaction details etc.
								this will maintain complete transparency between you and your
								corporate clients. Corporate Agent can make payment of due
								amount easily form online payment gateway. They can also send
								upload requests of their offline payments like Cash, Cheque,
								RTGS or Inter Bank Transfer.
							</p>
						</Grid>
					</Grid>
				</Container>

				<Divider />
			</div>

			<Footer />
		</div>
	);
};

export default B2ETP;
